import {useContext } from "react"
import {AppContext} from "../context/appContext";
import {types} from "../shared/types/types";

export const UseLoader = (  ) => {

    const {dispatch} = useContext(AppContext);

    const handleLoader = (value = false) => {
        const action = {
            type: types.loader,
            payload: value
        }
        dispatch(action)

    }

    return [ handleLoader ];

}
